export enum state {

  IPAlreadyExists = 0,
  DuplicateIPAddressReceived = 1,
  PasswordOrIpValidationError = 2,
  ConnectionErrorWithUnit = 3,
  InternalServerError = 4,
  ErrorWhileSendingData = 5

}
